/** Runs before browser instrumentation; the server already has the token. */
export function stripRecapTokenEarly(): void {
  if (!/^\/weekly(?:\/|$)/.test(window.location.pathname)) return;
  const url = new URL(window.location.href);
  if (!url.searchParams.has("token")) return;
  url.searchParams.delete("token");
  window.history.replaceState(window.history.state, "", url);
}
